// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Container = require("../common/Components/Container.bs.js");
let HtmlDisplayer = require("../common/Components/HtmlDisplayer.bs.js");
let PropertyPrice = require("../common/Components/PropertyPrice.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyLocationMap = require("../common/Components/PropertyLocationMap.bs.js");
let RentalPropertyLease = require("../common/Components/RentalPropertyLease.bs.js");
let ClientPropertyLocation = require("../common/Components/ClientPropertyLocation.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SharedPropertySidecard = require("./SharedPropertySidecard.bs.js");
let RentalPropertyAttributes = require("../common/Components/RentalPropertyAttributes.bs.js");
let SharedPropertyImageGallery = require("./SharedPropertyImageGallery.bs.js");
let SharedRentalPropertyStatus = require("./SharedRentalPropertyStatus.bs.js");
let SharedRentalProperty_property_graphql = require("../../__generated__/SharedRentalProperty_property_graphql.bs.js");
let SharedRentalProperty_sharedProperty_graphql = require("../../__generated__/SharedRentalProperty_sharedProperty_graphql.bs.js");

let convertFragment = SharedRentalProperty_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharedRentalProperty_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SharedRentalProperty_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharedRentalProperty_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SharedRentalProperty_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = SharedRentalProperty_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharedRentalProperty_sharedProperty_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SharedRentalProperty_sharedProperty_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharedRentalProperty_sharedProperty_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(SharedRentalProperty_sharedProperty_graphql.node, convertFragment$1, fRef);
}

let SharedPropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let baseClasses = "border-t border-gray-200 ";

function SharedRentalProperty$Divider(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "Base";
  let tmp;
  tmp = size === "Base" ? "my-8" : "my-12";
  return JsxRuntime.jsx("div", {
    className: baseClasses + tmp
  });
}

let Divider = {
  baseClasses: baseClasses,
  make: SharedRentalProperty$Divider
};

function SharedRentalProperty(props) {
  let property = RescriptRelay_Fragment.useFragment(SharedRentalProperty_property_graphql.node, convertFragment, props.property);
  let sharedProperty = RescriptRelay_Fragment.useFragment(SharedRentalProperty_sharedProperty_graphql.node, convertFragment$1, props.sharedProperty);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(SharedPropertyImageGallery.make, {
          property: property.fragmentRefs
        }),
        JsxRuntime.jsxs(Container.make, {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(ClientPropertyLocation.ByPropertyLocation.make, {
                          propertyLocation: sharedProperty.propertyLocation.fragmentRefs
                        }),
                        JsxRuntime.jsx(PropertyPrice.make, {
                          property: property.fragmentRefs
                        }),
                        JsxRuntime.jsx(RentalPropertyAttributes.make, {
                          property: property.fragmentRefs
                        }),
                        JsxRuntime.jsx(RentalPropertyLease.make, {
                          property: property.fragmentRefs
                        }),
                        JsxRuntime.jsx(SharedRentalPropertyStatus.make, {
                          property: property.fragmentRefs
                        })
                      ],
                      className: "flex flex-col space-y-4"
                    }),
                    JsxRuntime.jsx(SharedRentalProperty$Divider, {}),
                    JsxRuntime.jsx("section", {
                      children: JsxRuntime.jsx(HtmlDisplayer.make, {
                        text: sharedProperty.propertyDescription,
                        proseStyle: "md"
                      })
                    })
                  ]
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(SharedPropertySidecard.make, {
                      agent: sharedProperty.sender.fragmentRefs
                    }),
                    className: "max-w-sm"
                  }),
                  className: "md:flex w-full justify-end hidden"
                })
              ],
              className: "grid gap-16 grid-cols-1 md:grid-cols-[2fr_minmax(280px,1fr)]"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(SharedRentalProperty$Divider, {
                  size: "Large"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("section", {
                    children: [
                      JsxRuntime.jsx("h2", {
                        children: "Location",
                        className: "text-2xl font-medium text-gray-800"
                      }),
                      JsxRuntime.jsx(PropertyLocationMap.FromPropertyLocation.make, {
                        propertyLocation: sharedProperty.propertyLocation.fragmentRefs
                      })
                    ],
                    className: "flex flex-col gap-4"
                  }),
                  className: "flex flex-col gap-8"
                })
              ]
            })
          ]
        })
      ],
      className: "space-y-8 bg-white"
    })
  });
}

let Sidecard;

let make = SharedRentalProperty;

exports.PropertyFragment = PropertyFragment;
exports.SharedPropertyFragment = SharedPropertyFragment;
exports.Divider = Divider;
exports.Sidecard = Sidecard;
exports.make = make;
/* Container Not a pure module */
